import React from 'react';

const InfoIcon = ({color = '#A0AEC0'}) => {
  return (
    <svg
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Group'>
        <path
          id='Vector'
          d='M10.5 19.002C15.4706 19.002 19.5 14.9725 19.5 10.002C19.5 5.03139 15.4706 1.00195 10.5 1.00195C5.52944 1.00195 1.5 5.03139 1.5 10.002C1.5 14.9725 5.52944 19.002 10.5 19.002Z'
          stroke={color}
          stroke-width='1.75'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          id='Vector_2'
          d='M10.5 6.00195V10.002'
          stroke={color}
          stroke-width='1.75'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <g id='Vector_3'>
          <path d='M10.5 14H10.51H10.5Z' fill={color} />
          <path
            d='M10.5 14H10.51'
            stroke={color}
            stroke-width='2.625'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </g>
      </g>
    </svg>
  );
};

export default InfoIcon;
